import React, { useState, useEffect } from 'react'
import { getNonEmpty } from '../../../../utils/helpers';
import EditIcon from "@material-ui/icons/Edit";
import { buttonsStyle } from "../../../components/tables/table";
import {
    Button,
    Tooltip
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { NewTable } from "../customers/EditCustomerPage";
import { getAllActiveSubPlans } from '../../../../api/subPlan'
import { alertError, alertSuccess } from '../../../../utils/logger'
import {
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';


export default function TablePlan({ data, setData, setFeatureSelected, setFeaturesOpen, setNewFeature, setSelectedPlans, tableKey, setTableKey }) {
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [plans, setPlans] = useState([])
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [dataId, setDataId] = useState(null)
    const [orderId, setOrderId] = useState(null)


    useEffect(() => {
        getAllActiveSubPlans()
            .then(res => {
                const data = res.data.map(item => ({
                    ...item,
                    title: item.target.charAt(0).toUpperCase() + item.target.slice(1).toLowerCase() + " - " + getNonEmpty(item.title)
                }))
                setPlans(data)
            }
            )
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get subscription plans.' })
            })

    }, [])

    function buttonFormatter(cell) {
        const currentIndex = data.findIndex((item) => item.order === cell);
        const prevId = currentIndex > 0 ? data[currentIndex - 1].order : null;
        const nextId = currentIndex < data.length - 1 ? data[currentIndex + 1].order : null;

        const elem = data.find((item) => item.order === cell);


        const swapItems = (from, to) => {
            const updatedData = [...data];
            const temp = updatedData[from];
            updatedData[from] = updatedData[to];
            updatedData[to] = temp;

            const reordered = updatedData.map((item, index) => ({
                ...item,
                order: index,
            }));

            setData(reordered);
            setTableKey(k => k + 1);
        };
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setFeatureSelected(elem)
                            setSelectedPlans(elem.subPlan)
                            setFeaturesOpen(true)
                            setNewFeature(false)
                        }
                        }
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setOpenConfirmDialog(true)
                                    //setDataId(elem._id)
                                    setOrderId(cell)
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
                {prevId !== null && prevId !== undefined && (
                    <Tooltip title="Move Up">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                swapItems(currentIndex, currentIndex - 1)
                            }}
                        >
                            <ArrowUpward />
                        </Button>
                    </Tooltip>
                )}
                {nextId !== null && nextId !== undefined && (
                    <Tooltip title="Move Down">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                swapItems(currentIndex, currentIndex + 1)
                            }}
                        >
                            <ArrowDownward />
                        </Button>
                    </Tooltip>
                )}
            </>
        );
    }

    function checkFormatter(row, idPlan) {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={Array.isArray(row.subPlan) && idPlan && row.subPlan.includes(idPlan)}
                            name="checkActive"
                            disabled
                        />
                    }
                />
            </>
        );
    }


    const dynamicPlanColumns = [];
    for (let i = 0; i < plans.length; i++) {
        const idPlan = plans[i]._id;
        dynamicPlanColumns.push({
            dataField: `plans${i}`,
            text: `${plans[i].title}`,
            formatter: (_, row) => checkFormatter(row, idPlan),
            headerStyle: { width: '125px' },
        });
    }

    const columns = [
        { dataField: "title", text: "Title", formatter: (cell, row) => getNonEmpty(row.title) },
        ...dynamicPlanColumns,
        {
            dataField: "order",
            text: "",
            formatter: buttonFormatter,
            headerStyle: { width: '200px' }
        },
    ];


    return (
        <>
            <div className="col-12">
                <NewTable key={tableKey} data={data} columns={columns} />
            </div>

            <ConfirmDialog
                title={"Are you sure you want to delete this feature plan?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    const updatedData = data
                        .filter(item => item.order !== orderId)
                    setData([...updatedData]);
                    alertSuccess({
                        title: "Deleted!",
                        customMessage: "Feature plan deleted successfully.",
                    });
                }}
            />
        </>
    );


}